import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { ProjectNameDataDDL } from '../../../../Components/CommonDDL/ProjectNameDataDDL';
import { WorkTypeDDL } from '../../../../Components/CommonDDL/WorkTypeDDL';
import { ProjectWiseWorkNamePostDataAPI } from '../../../../Redux/SidebarMasterSlice/ProjectWiseWorkName';
import { WorkSubTypeDDL } from '../../../../Components/CommonDDL/WorkSubTypeDDL';
import { WorkNameDDL } from '../../../../Components/CommonDDL/WorkNameDDL';
import { ProjectTypeDataDDL } from '../../../../Components/CommonDDL/ProjectTypeDataDDL';
import { GDProjectNameDDL } from '../../../../Components/CommonDDL/GDProjectNameDDL';
import { useTranslation } from 'react-i18next';


export default function ProjectWiseWorkNamePopup(props) {

    const { handleOnCloseClick, open, handleIsPost, Flag, apiFlag, rowData, Lang } = props

    const { t } = useTranslation()

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails
    const dispatch = useDispatch()

    // const [rowData, setRowData] = useState(rowData)
    const [IsOpen, setIsOpen] = useState(false)

    console.log(rowData)
    // const [WardName, setWardName] = useState({
    //     DDL: [],
    //     ID: Flag === 'Update' ? rowData.m_WardID : 0,
    //     Label: Flag === 'Update' ? rowData.wardName : "Select...",
    // })

    const [ProjectType, setProjectType] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_ProjectTypeID : 0,
        Label: Flag === 'Update' ? rowData.projectType : "Select...",
    })
    const [ProjectName, setProjectName] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_ProjectID : 0,
        Label: Flag === 'Update' ? rowData.projectName : "Select...",
    })
    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_WorkTypeID : 0,
        Label: Flag === 'Update' ? rowData.workTypeName : "Select...",
    })
    const [WorkSubType, setWorkSubType] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_WorkSubTypeID : 0,
        Label: Flag === 'Update' ? rowData.workSubTypeName : "Select...",
    })

    const [WorkName, setWorkName] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_WorkID : 0,
        Label: Flag === 'Update' ? rowData.projectWorkname : "Select...",
    })

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: Lang,
    })


    // console.log(Flag, EmployeeField)
    const handleClearField = () => {
        if (Flag != 'Update') {
            // setSectorName('')
        }
    }

    const handlePost = () => {
        const data = {
            M_ProjectWiseWorkID: Flag === 'Update' ? rowData.m_ProjectWiseWorkID : '0',
            M_ProjectID: ProjectName.ID,
            M_WorkID: WorkName.ID,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleClearField: handleClearField,
            handleOnCloseClick: handleOnCloseClick,
            Language: Lang
        }
        dispatch(ProjectWiseWorkNamePostDataAPI({ data }))

    }

    // const [showPopup, setShowPopup] = useState(false);

    return (

        // <Popup
        //     onOpen={() => setIsOpen(!IsOpen)}
        //     contentStyle={{ top: '5%' }}
        //     trigger={
        //         Flag === 'Update' ?
        //             <i className="fa-solid fa-pen-to-square" style={{ cursor: "pointer" }} title='Edit'></i>
        //             :
        //             <i className="fa-solid fa-plus btn btn-secondary float-end mb-2" style={{ color: "white", marginTop: '-2.5em' }}>
        //                 <text className="ml-2 poppins">Add</text>
        //             </i>
        //     }
        //     modal>

        //     {
        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick} contentStyle={{ width: "65vw" }}
        >
            <div className="area_pop modal-dialog-scrollable modal-dialog modal-xl">
                <div className="modal-content master_border" style={{ borderTop: "7px solid black" }}>
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Project Wise Work Name</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">
                                {/* <div className="col-12 col-lg-6">
                                    <ProjectTypeDataDDL
                                        ProjectType={ProjectType}
                                        setProjectType={setProjectType}
                                        rowData={rowData}
                                        Flag={Flag}
                                    />
                                </div> */}
                                <div className="col-12 col-lg-6 ">
                                    <GDProjectNameDDL
                                        ProjectName={ProjectName}
                                        setProjectName={setProjectName}
                                        rowData={rowData}
                                        Flag={Flag}
                                        M_ProjectTypeID={ProjectType.ID}
                                        DDLFlag='ProjectWiseWorkName'
                                    />
                                </div>
                                <div className="col-12 col-lg-6 ">
                                    <WorkTypeDDL
                                        WorkType={WorkType}
                                        setWorkType={setWorkType}
                                        WorkSubType={WorkSubType}
                                        setWorkSubType={setWorkSubType}
                                        Flag={Flag}
                                        rowData={rowData}
                                    />

                                </div>
                                <div className="col-12 col-lg-6 ">
                                    <WorkSubTypeDDL
                                        WorkSubType={WorkSubType}
                                        setWorkSubType={setWorkSubType}
                                        WorkType={WorkType}
                                        WorkName={WorkName}
                                        setWorkName={setWorkName}
                                        Flag={Flag}
                                        rowData={rowData}
                                    />
                                </div>
                                <div className="col-12 col-lg-6 ">
                                    <WorkNameDDL
                                        WorkName={WorkName}
                                        setWorkName={setWorkName}
                                        WorkType={WorkType}
                                        WorkSubType={WorkSubType}
                                        Flag={Flag}
                                        rowData={rowData}
                                        Language={Lang}
                                    />
                                </div>

                            </div>

                            <div className="col-12 col-lg-12 mt-lg-5 mb-lg-3">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">

                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            ProjectName.ID == 0 || WorkType.ID === 0 || WorkSubType.ID == 0 || WorkName.ID == 0
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            {/* )} */}


        </Popup>
    )

}